import React, { memo } from 'react';

import bn from '../../generalUtils/benames';
import { IMG_PAGESPINNER_GIF } from '../../constants/imagesAssetsConst';

const bemPageSpinner = bn.create('PageSpinner');

const PageSpinner = ({ isLoading = true, isMainLayout = true }) => {
  const loaderClass = isMainLayout ? 'dip-loader' : 'dip-full-loader';
  const divtag = (
    <div className={bemPageSpinner.b('')}>
      <div
        style={{ backgroundImage: `url(${isLoading ? IMG_PAGESPINNER_GIF : ''})` }}
        className={isLoading ? `${loaderClass} show-loader` : `${loaderClass} hide-loader`}
      />
    </div>
  );
  return divtag;
};

export default memo(PageSpinner);
